var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_463_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7756 2.63333C16.3068 2.16466 15.671 1.90137 15.0081 1.90137C14.3452 1.90137 13.7094 2.16466 13.2406 2.63333L12.6514 3.22333L16.7764 7.34833L17.3648 6.75917C17.597 6.52702 17.7812 6.2514 17.9068 5.94806C18.0325 5.64472 18.0972 5.31959 18.0972 4.99125C18.0972 4.66291 18.0325 4.33779 17.9068 4.03444C17.7812 3.7311 17.597 3.45549 17.3648 3.22333L16.7756 2.63333ZM15.5973 8.52667L11.4723 4.40167L3.89728 11.9775C3.73151 12.1433 3.61572 12.3524 3.56311 12.5808L2.70561 16.2933C2.67366 16.4312 2.67732 16.5748 2.71626 16.7109C2.7552 16.8469 2.82812 16.9707 2.92816 17.0708C3.0282 17.1708 3.15206 17.2437 3.28808 17.2827C3.4241 17.3216 3.56779 17.3253 3.70561 17.2933L7.41894 16.4367C7.64712 16.3839 7.85588 16.2681 8.02144 16.1025L15.5973 8.52667Z",
    fill: "#6C74CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_463_1763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.93c5a9c1e4d3aa7c9a0a429811e420fd.svg";
export { ForwardRef as ReactComponent };